export const gtm = {
    openedPages: new Set<string>(),

    push(data: Record<string, any>) {
        if (process.client) {
            const dataLayer = (window as any).dataLayer
            if (!dataLayer || !data) return
            dataLayer.push(data)
        }
    },

    openPage(type: string) {
        if (process.client) {
            this.openedPages.add(type)
            this.push({
                event: 'page.open',
                type
            })
        }
    },

    event(event: string, value: string) {
        this.push({
            event: 'ga-event',
            eventCategory: event,
            eventAction: value
        })
    },

    banner(code: string, name: string) {
        this.push({
            event: 'ga-event',
            eventCategory: 'Banner',
            eventAction: 'click',
            eventLabel: name,
            eventValue: code
        })
    }
}
